







































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import DeliverySlaRequest from '@/model/request/DeliverySlaRequest'
import ItDateInput from '@/components/itrack/ItDateInput.vue'
import {IResource, ObjectCollection} from 'simpli-web-sdk'
import {ItrackCollection} from '@/helpers'

@Component({
  components: {ItDateInput},
})
export default class FilterDeliverySla extends Mixins(MixinMember) {
  @Prop({type: Object, required: true}) value!: DeliverySlaRequest

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  async mounted() {
    await this.value.allTipoInsumo.query()
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
